import PropTypes from 'prop-types'

import { getColors } from '../../utils'

export default function ScoreIndicator({ group_match }) {
  const { dark, medium, light } = getColors({ score: group_match })
  return (
    <div className='flex h-10 w-10 flex-col items-center'>
      <span style={{ color: dark }} className='text-2xl font-semibold'>
        {Math.round(group_match)}
      </span>
      <div
        style={{ backgroundColor: light }}
        className='h-1 w-full rounded-full'
      >
        <div
          style={{ backgroundColor: medium, width: `${group_match}%` }}
          className={`h-1 rounded-full`}
        />
      </div>
    </div>
  )
}

ScoreIndicator.propTypes = {
  group_match: PropTypes.number.isRequired
}
